import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { fetchChangelog } from '../api/changelog';
import { ChangelogGroups } from '../components/WhatsNewDialog';
import ConsolePanel from '../components/ConsolePanel';
import { C, FONT, frameSx, revealSx } from '../theme/tokens';

/**
 * The full release history behind the popup — every entry, not just the
 * newest one. Reachable from the What's New dialog's "Full history" link
 * and directly at /whats-new, for whenever "when did we ship that" needs an
 * actual answer instead of a memory of the last popup.
 */
const WhatsNew: React.FC = () => {
  const { data: entries, isLoading } = useQuery({ queryKey: ['changelog'], queryFn: fetchChangelog });

  return (
    <Stack spacing={2.5} sx={revealSx()}>
      <Typography variant="h1" sx={{ color: C.text, fontFamily: FONT.display, fontSize: '1.7rem' }}>
        What&rsquo;s New
      </Typography>

      {isLoading ? (
        <CircularProgress size={20} sx={{ color: C.cyan }} />
      ) : !entries || entries.length === 0 ? (
        <Typography sx={{ color: C.textDim }}>No release history yet.</Typography>
      ) : (
        <Stack spacing={2}>
          {entries.map((entry) => (
            <ConsolePanel
              key={entry.version}
              title={`v${entry.version}${entry.date ? ` — ${entry.date}` : ''} — ${entry.title}`}
              accent={C.gold}
              corners={false}
              sx={frameSx(C.gold)}
            >
              <ChangelogGroups entry={entry} />
            </ConsolePanel>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default WhatsNew;
